var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.draw_items, function (product) {
      return _c(
        "div",
        { staticClass: "prod_info" },
        [
          _c("product_inside", {
            key: "prod_inside_" + _vm.id,
            attrs: {
              show_remove: _vm.show_remove,
              show_select: _vm.show_select,
              product: product,
            },
            on: {
              remove_product: _vm.remove_item,
              select_product: _vm.select_product,
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }